
import React from 'react';
import { Event } from '@/lib/types';
import { format } from 'date-fns';
import { Calendar } from 'lucide-react';
import CalendarEvent from '@/components/CalendarEvent';

interface CalendarDayCellProps {
  day: Date;
  index: number;
  dayEvents: Event[];
  isEmpty: boolean;
  isToday?: boolean;
  cellWidth: number;
  maxVerticalPosition: number;
  onEventClick: (event: Event) => void;
}

const CalendarDayCell: React.FC<CalendarDayCellProps> = ({
  day,
  index,
  dayEvents,
  isEmpty,
  isToday = false,
  cellWidth,
  maxVerticalPosition,
  onEventClick
}) => {
  const dayKey = format(day, 'yyyy-MM-dd');
  
  // Calculate space to reserve for multi-day events
  // Each row is 32px high, add extra padding at the bottom
  const topMargin = (maxVerticalPosition + 1) * 32 + 8;
  
  return (
    <div
      key={`cell-${index}-${dayKey}`}
      className={`border-r last:border-r-0 border-medihub-midPurple/20 min-h-[180px] relative font-sans
        ${isEmpty ? 'bg-medihub-softBg' : 'bg-medihub-cardBg'}
        ${isToday ? 'bg-medihub-softGray/70' : ''}`}
      style={{ 
        width: `${cellWidth}px`, // Dynamic width based on cellWidth prop
        minWidth: `${cellWidth}px`, // Ensure minimum width is respected
        maxWidth: `${cellWidth}px`  // Ensure maximum width is respected
      }}
    >
      {isEmpty ? (
        <div className="h-full flex flex-col items-center justify-center text-medihub-secondary/40 p-2">
          <Calendar className="h-5 w-5 mb-1 opacity-40" />
          <div className="text-xs text-center">Nincsenek események</div>
        </div>
      ) : (
        <div
          className="space-y-1 p-1.5 max-w-full"
          style={{
            // Reserve space for multi-day events at the top
            marginTop: `${topMargin}px`
          }}
        >
          {dayEvents.map((event, eventIndex) => (
            <CalendarEvent
              key={`single-${event.id}-${eventIndex}`}
              event={event}
              onClick={onEventClick}
              cellWidth={cellWidth}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CalendarDayCell;
